import store from './store';

function isOwner() {
    let current_vault_owner = store.getters.getCurrentVault.user_id;
    let current_user = store.getters.getUser.id;

    if (current_vault_owner == current_user) {
        return true;
    }

    return false;
}

export default {
    roles: {
        userA: {
            handler: function () {
                return this.$auth.isAuthenticated()
            },
            permissions: [
                'superuser',
                'can_access_billing_invoicing',
                'can_view_members',
                'can_add_members',
                'can_delete_members',
                'can_edit_members',
                'can_edit_role',
                'can_manage_roles_restrictions',
                'can_upload',
                'can_file_document',
                'can_tag_document',
                'can_update_document',
                'can_delete_document_before_filing',
                'can_delete_document_after_filing',
                'can_archive',
                'can_download',
                'can_view_discussions',
                'can_add_discussions',
                'can_edit_discussions',
                'can_delete_discussions',
                'can_view_tasks',
                'can_add_tasks',
                'can_edit_tasks',
                'can_view_events',
                'can_add_events',
                'can_edit_events',
                'can_access_dashboard',
                'can_view_info',
                'can_edit_vault_details',
                'can_access_all_files',
                'can_manage_tags',
                'can_transfer_ownership',
                'can_bulk_download',
                'can_add_key_document',
                'can_edit_key_document',
                'can_replace_tag',
            ]
        },

        userB: {
            handler: function () {
                return this.$auth.isAuthenticated()
            },
            permissions: [
                'can_view_members',
                'can_add_members',
                'can_delete_members',
                'can_edit_members',
                'can_edit_role',
                'can_manage_roles_restrictions',
                'can_upload',
                'can_file_document',
                'can_tag_document',
                'can_update_document',
                'can_delete_document_before_filing',
                'can_delete_document_after_filing',
                'can_archive',
                'can_download',
                'can_view_discussions',
                'can_add_discussions',
                'can_edit_discussions',
                'can_view_tasks',
                'can_add_tasks',
                'can_edit_tasks',
                'can_view_events',
                'can_add_events',
                'can_edit_events',
                'can_access_dashboard',
                'can_edit_vault_details',
                'can_view_info',
                'can_access_all_files',
                'can_manage_tags',
                'can_add_key_document',
                'can_edit_key_document',
                'can_replace_tag',
            ]
        },

        userC: {
            handler: function () {
                return this.$auth.isAuthenticated()
            },
            permissions: [
                'can_upload',
                'can_file_document',
                'can_tag_document',
                'can_update_document',
                'can_delete_document_before_filing',
                'can_archive',
                'can_download',
                'can_view_discussions',
                'can_add_discussions',
                'can_edit_discussions',
                'can_view_tasks',
                'can_add_tasks',
                'can_edit_tasks',
                'can_view_events',
                'can_add_events',
                'can_edit_events',
                'can_access_dashboard',
                'can_view_info',
                'can_access_all_files',
                'can_view_members'

                // 'can_transfer_ownership' // for voting process, not yet implemented, commenting out
            ]
        },

        userD: {
            handler: function () {
                return this.$auth.isAuthenticated()
            },
            permissions: [
                // 'can_upload',
                // 'can_file_document',
                // 'can_tag_document',
                // 'can_update_document',
                // 'can_delete_document_before_filing',
                'can_download',
                'can_view_discussions',
                'can_add_discussions',
                'can_edit_discussions',
                'can_view_tasks',
                'can_add_tasks',
                'can_edit_tasks',
                'can_view_events',
                'can_add_events',
                'can_edit_events',
                'can_access_dashboard',
                'can_view_info',
                'can_access_all_files',
                'can_view_members'
            ]
        },

        userE: {
            handler: function () {
                return this.$auth.isAuthenticated()
            },
            permissions: [
                'can_download',
                'can_view_info',
            ]
        },

        userF: {
            handler: function () {
                return this.$auth.isAuthenticated()
            },
            permissions: [
                'can_access_dashboard',
                'can_download',
                'can_view_info',
                'can_view_events',
                'can_bulk_download',
            ]
        },

        userG: {
            handler: function () {
                return this.$auth.isAuthenticated()
            },
            permissions: [
                'can_download',
                'can_view_discussions',
                'can_view_tasks',
                'can_view_events',
                'can_access_dashboard',
                'can_view_info',
                'can_access_all_files',
                // 'can_view_members',
                // 'can_bulk_download',
            ]
        },
    },

    permissions: {
        superuser: function () { // Duh? Self explanatory
            return true
        },
        can_add_members: function () { // Add Members
            return true
        },
        can_delete_members: function () { // Delete Members
            return true
        },
        can_view_members: function () { // View Members
            return true
        },
        can_edit_members: function () { // Edit Members
            return true
        },
        can_access_all_files: function () {
            return true
        },
        can_archive: function () { // Archive Documents
            return true
        },
        can_upload: function () { // Can Upload Documents
            return true
        },
        can_download: function () { // Download Documents
            return true
        },
        can_view: function () {
            return true
        },
        can_reinstate_archive: function () {
            return true
        },
        can_view_info: function () {
            return true
        },
        can_view_archives: function () {
            return true
        },
        can_vote: function () {
            return true
        },
        can_edit_vault_details: function () {
            return true;
        },
        can_access_billing_invoicing: function () { // Viewing Billing and Invoicing
            return isOwner();
        },
        can_access_dashboard: function () {
            return true;
        },
        can_manage_roles_restrictions: function () { // Assign who can view a specific tag
            return true;
        },
        can_transfer_ownership: function () { // Transfer ownership
            return isOwner();
        },
        can_manage_tags: function () {
            return true;
        },
        can_edit_role: function () { // Edit Member Role
            return true;
        },
        can_file_document: function () { // File Document
            return true;
        },
        can_tag_document: function () { // Tag Document
            return true;
        },
        can_update_document: function () { // Update Document
            return true;
        },
        can_delete_document_before_filing: function () { // Delete Document before Filing
            return true;
        },
        can_delete_document_after_filing: function () { // Delete Document before Filing
            return true;
        },
        can_view_discussions: function () { // View Discussions
            return true;
        },
        can_add_discussions: function () { // Add Discussions
            return true;
        },
        can_edit_discussions: function () { // Edit Discussions
            return true;
        },
        can_delete_discussions: function () { // Delete Discussions
            return true;
        },
        can_view_tasks: function () { // View Tasks
            return true;
        },
        can_add_tasks: function () { // Ad Tasks
            return true;
        },
        can_edit_tasks: function () { // Edit Tasks
            return true;
        },
        can_view_events: function () { // View events
            return true;
        },
        can_add_events: function () { // Ad events
            return true;
        },
        can_edit_events: function () { // Edit events
            return true;
        },
        can_bulk_download: function () {
            return true;
        },
        can_add_key_document: function() {
            return true;
        },
        can_edit_key_document: function() {
            return true;
        },
        can_replace_tag: function() {
            return true;
        },
    }
}